import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import { editCaseLocationInfo } from "../../../../services/typedefine";
import { GET_ATTACHMENT_FILE_DOWNLOAD } from "../../../../services";
import { apiGetWithHeader } from "../../../../services/service";
import './location-info.css';
import { Trans, useTranslation } from "react-i18next";
const LocationInfo: React.FC<editCaseLocationInfo> = ({ locationInfoSummary }) => {

  const downloadAttachmentHandler = async () => {
    try {
      const res = await apiGetWithHeader(GET_ATTACHMENT_FILE_DOWNLOAD + locationInfoSummary.ProductNumberEditPage);
      if (res.data) {
        console.log(res, 'res....')
      }

    } catch (error) {
      console.error("Error fetching recent cases:", error);
    }
  }
  const {t} = useTranslation();

  return (
    <div className="location-info">
      <Container className="container-custom">
        <Row>
        <Col md={6} className="container-row">
        <Row>
          <Col><h4>{t("HPI.EditCase.contactandequip.Contact",{defaultValue:'Contact (Submitter)'})}</h4></Col>
        </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequip.Firstname",{defaultValue:'First name:'})}</Col>
            <Col>{locationInfoSummary.SubFirstName}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequip.Lastname",{defaultValue:'Last name:'})}</Col>
            <Col>{locationInfoSummary.SubLastName}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequip.Phonenumber",{defaultValue:'Phone number:'})}</Col>
            <Col>{locationInfoSummary.SubPhnNum}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequip.Email",{defaultValue:'Email:'})}</Col>
            <Col>{locationInfoSummary.SubEmail }</Col>
          </Row>
        </Col>
        <Col md={6} className="container-row">
        <Row>
          <Col><h4>{t("HPI.EditCase.contactandequipaltername.ContactAlternate",{defaultValue:'Contact (Alternate)'})}</h4></Col>
        </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequipaltername.Firstname",{defaultValue:'First name:'})}</Col>
            <Col>{locationInfoSummary.ALtFirstName}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequipaltername.Lastname",{defaultValue:'Last name:'})}</Col>
            <Col>{locationInfoSummary.AltLastName}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequipaltername.Phonenumber",{defaultValue:'Phone number:'})}</Col>
            <Col>{locationInfoSummary.AltPhnNum}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.contactandequipaltername.Email",{defaultValue:'Email:'})}</Col>
            <Col>{locationInfoSummary.AltEmail}</Col>
          </Row>
          
        </Col>
        </Row>
        <Row>
        <Col md={6} className="container-row">
        <Row>
          <Col><h4>{t("HPI.EditCase.Equipment.Equipmentlocation",{defaultValue:'Equipment location'})}</h4></Col>
        </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.Compayname",{defaultValue:'Site name:'})}</Col>
            <Col>{locationInfoSummary.EquipCompany}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.Equipmentcontact",{defaultValue:'Equipment contact:'})}</Col>
            <Col>{locationInfoSummary.EquipContact}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.Contactphone",{defaultValue:'Contact phone:'})}</Col>
            <Col>{locationInfoSummary.EquipPhnNum}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.EquipEmail",{defaultValue:'Email:'})}</Col>
            <Col>{locationInfoSummary.EquipEmail}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.Address",{defaultValue:'Address:'})}</Col>
            <Col>{locationInfoSummary.EquipAddress}</Col>
          </Row>
          
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.Citytown",{defaultValue:'City/Town:'})}</Col>
            <Col>{locationInfoSummary.EquipCity}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.StateProvince",{defaultValue:'State/Province:'})}</Col>
            <Col>{locationInfoSummary.EquipState}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.ZipPostalcode",{defaultValue:'Zip/Postal code:'})}</Col>
            <Col>{locationInfoSummary.EquipPincode}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.Equipment.CountryRegion",{defaultValue:'Country:'})}</Col>
            <Col>{locationInfoSummary.EquipCountry}</Col>
          </Row>
         
        </Col>
        <Col md={6} className="container-row">
        <Row>
          <Col><h4>{t("HPI.EditCase.shipparts.shipparts",{defaultValue:'Ship parts and service delivery address'})}</h4></Col>
        </Row>
        <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.Companyname",{defaultValue:'Site name:'})}</Col>
            <Col>{locationInfoSummary.ShipCompany}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.Equipmentcontact",{defaultValue:'Equipment contact:'})}</Col>
            <Col>{locationInfoSummary.ShipContact}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.Contactphone",{defaultValue:'Contact phone:'})}</Col>
            <Col>{locationInfoSummary.ShipPhnNum}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.ShipEmail",{defaultValue:'Email:'})}</Col>
            <Col>{locationInfoSummary.ShipEmail}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.Address",{defaultValue:'Address:'})}</Col>
            <Col>{locationInfoSummary.ShipAddress}</Col>
          </Row>
          
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.Citytown",{defaultValue:'City/Town:'})}</Col>
            <Col>{locationInfoSummary.ShipCity}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.StateProvince",{defaultValue:'State/Province:'})}</Col>
            <Col>{locationInfoSummary.ShipState}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.ZipPostalcode",{defaultValue:'Zip/Postal code:'})}</Col>
            <Col>{locationInfoSummary.ShipPincode}</Col>
          </Row>
          <Row>
            <Col md={4}>{t("HPI.EditCase.shipparts.CountryRegion",{defaultValue:'Country:'})}</Col>
            <Col>{locationInfoSummary.ShipCountry}</Col>
          </Row>
         
        </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LocationInfo;
